import { MediaLibrary } from '@/components/admin'

export function Media() {
  return <MediaLibrary />
}
